import { AIDataSource } from '@logz-pkg/enums';
import { dateToAbsolute, isRelativeDate } from '@logz-pkg/utils';
import moment from 'moment';
const buildAgentRecordByIndex = ({ index, chatResponse, }) => {
    const { message } = chatResponse;
    const title = message?.slice(0, 140);
    const messageLength = index;
    const stepNumberToSubTitle = messageLength >= 10 ? messageLength : `0${messageLength}`;
    const subTitle = `Step ${stepNumberToSubTitle}`;
    return {
        type: 'Collapse',
        role: 'Ai',
        content: message ?? '',
        subTitle,
        title,
        shouldContinue: chatResponse.shouldContinue,
    };
};
export const addAgentInvocation = (chatResponse, historyItems) => {
    const data = chatResponse;
    const { actionGroupInvocationInput } = data;
    const { function: functionName, parameters } = actionGroupInvocationInput ?? {};
    const invocation = { functionName, parameters };
    ['start_time', 'end_time'].forEach(key => {
        const parameter = parameters?.find(param => param.name === key);
        if (parameter && isRelativeDate(parameter.value)) {
            parameter.value = `${dateToAbsolute(parameter.value) * 1000}`;
        }
    });
    const last = historyItems.at(-1);
    last.invocationFunctions = last?.invocationFunctions ? [...last.invocationFunctions, invocation] : [invocation];
};
const getLoadingComponents = ({ prompt, componentType, context, dataSource, }) => {
    const addToState = {
        content: prompt,
        role: 'User',
        type: componentType,
        createdAt: moment().format(),
    };
    if (context) {
        addToState.information = context;
    }
    const loadingPrompt = {
        content: dataSource === AIDataSource.RCA ? 'Root cause analysis' : 'Answer',
        role: 'System',
        type: 'Loading',
    };
    return [addToState, loadingPrompt];
};
const generateRandomString = (length) => Array.from({ length }, () => Math.random().toString(36)[2]).join('');
const getNewSessionId = () => `logz-observability-ai-${generateRandomString(16)}`;
export const bedrockUtils = {
    getNewSessionId,
    generateRandomString,
    buildAgentRecordByIndex,
    addAgentInvocation,
    getLoadingComponents,
};
//# sourceMappingURL=bedrock.js.map